import { render, staticRenderFns } from "./componentsMarket.vue?vue&type=template&id=3b7dc039&scoped=true"
import script from "./componentsMarket.vue?vue&type=script&lang=js"
export * from "./componentsMarket.vue?vue&type=script&lang=js"
import style0 from "./componentsMarket.vue?vue&type=style&index=0&id=3b7dc039&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b7dc039",
  null
  
)

export default component.exports